export class EbmlIds {
    /**
     * Indicates an EBML Header element.
     */
    public static readonly EBML_HEADER = 0x1A45DFA3;

    /**
     * Indicates an EBML Version element.
     */
    public static readonly EBML_VERSION = 0x4286;

    /**
     * Indicates an EBML Read Version element.
     */
    public static readonly EBML_READ_VERSION = 0x42F7;

    /**
     * Indicates an EBML Max ID Length element.
     */
    public static readonly EBML_MAX_IDLENGTH = 0x42F2;

    /**
     * Indicates an EBML Max Size Length element.
     */
    public static readonly EBML_MAX_SIZE_LENGTH = 0x42F3;

    /**
     * Indicates an EBML Doc Type element.
     */
    public static readonly EBML_DOC_TYPE = 0x4282;

    /**
     * Indicates an EBML Doc Type Version element.
     */
    public static readonly EBML_DOC_TYPE_VERSION = 0x4287;

    /**
     * Indicates an EBML Doc Type Read Version element.
     */
    public static readonly EBML_DOC_TYPE_READ_VERSION = 0x4285;

    /**
     * Indicates an EBML Void element.
     */
    public static readonly EBML_VOID = 0xEC;
}
